<section>
  <header>
    <h1 auto="planning-step-3-title">Planning Phase</h1>
  </header>
  <div class="information-container">
    <div>
      <p><strong>Develop Strategy Map</strong></p>
      <p>
        The institution’s Strategy Map is populated once specific steps are completed in the first two subphases. By selecting View Strategy Map, you can view and download this communication document that represents the institution’s long-term direction.
      </p>
    </div>
    <div class="explanation-margin">
      <div class="download-guide-container">
        <img class="book-icon pointer" src="assets/images/download-guide-icon.svg" alt="book-icon" (click)="openGuide()">
        <span class="download-tagline pointer" (click)="openGuide()">Download the guide</span> to learn more about <strong>Developing a Strategy Map</strong>.
      </div>
    </div>
  </div>
  <button auto="view-strat-map-btn" class="btn btn-primary deliverable-button"
          (click)="onPlanCoordinateChangeStrategyMap()">View Strategy Map</button>
  <div class="spacer"></div>
</section>
